import React from 'react'
import { CreditCard } from 'lucide-react'
import { PlaceholderPage } from '@/components/PlaceholderPage'

export const AccountingSpendPage: React.FC = () => (
  <PlaceholderPage
    icon={CreditCard}
    titleKey="business.accountingSpendTitle"
    descriptionKey="business.accountingSpendDescription"
  />
)
